import { UtilsService } from 'src/app/services/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, AfterViewInit, ViewChild, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { OfficeSelectorComponent } from '../../consultant/office-selector/office-selector.component';
import { fromConsultant } from 'src/app/reducers/consultant.reducer';
import { Consultant } from 'src/app/models/consultant.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { setOffice } from 'src/app/actions/consultant.actions';
import { JobtypeService } from 'src/app/services/jobtype.service';
import { TestService } from 'src/app/services/test.service';
import { ProcessService } from 'src/app/services/process.service';
import { setJobtypes } from 'src/app/actions/jobtypes.actions';
import { setTestModels } from 'src/app/actions/test-models.actions';
import { setProcesses } from 'src/app/actions/processes.actions';
import * as helpers from '../../../helpers/helpers';
import { AppConfig } from 'src/app/helpers/app.config';
import { setCompanies } from 'src/app/actions/companies.actions';
import { CompanyService } from 'src/app/services/company.service';

@Component({
  selector: 'ct-consultant-header',
  templateUrl: './consultant-header.component.html',
  styleUrls: ['./consultant-header.component.scss']
})
export class ConsultantHeaderComponent implements OnInit, AfterViewInit {

  @ViewChild(OfficeSelectorComponent) officeSelector;

  public consultant$: Observable<Consultant>;
  public title = 'relevate talent assessment';
  constructor(
    private store: Store,
    private ngZone: NgZone,
    private router: Router,
    private jobtypeService: JobtypeService,
    private testService: TestService,
    private processService: ProcessService,
    private companyService: CompanyService,
    public authenticationService: AuthenticationService,
    public translateService: TranslateService,
    public utilsService: UtilsService
  ) { }

  ngOnInit(): void {
    this.consultant$ = this.store.pipe(select(fromConsultant.selectConsultantState));
  }

  ngAfterViewInit(): void {
    this.consultant$.subscribe(consultant => {
      if (consultant?.token && !consultant.office && !consultant.permissions) {
        // Revisamos si es el CLiente España para saber si mostrar el selector de oficina
        if (consultant.client.id === 1) {
          this.officeSelector.open();
        }
        // si es internacional
        else {
          // Seteamos el idioma del cliente
          this.translateService.setDefaultLang(this.utilsService.getLanguageFromLanguageId(consultant.client.id));
          this.translateService.use(consultant.client.defaultLanguage);
          document.documentElement.lang = consultant.client.defaultLanguage.split('-')[0];

          this.ngZone.run(() => {
            this.companyService.index(consultant.client.id).subscribe(companies => {
              if (companies.length) {
                this.store.dispatch(setCompanies({ companies }));
              } else {
                this.utilsService.toast('warning', 'NoPermissions');
                this.authenticationService.logOut('consultant');
                setTimeout(() => {
                  location.href = AppConfig.settings.LOGOUT_FBI;
                }, 5000);
              }

              // Seleccionamos la oficina internacional que corresponde con el appbusiness
              let office = companies[0].offices.find(office => office.randstadOffice === Number(consultant.googleDirectory.customSchemas?.Contact?.appbusiness));
              if (!office) {
                office = companies[0].offices.find(office => office.randstadOffice === Number(consultant.googleDirectory.organizations[0].department));
              }

              const businessAreas = helpers.getBusinessFromOffice(office);
              const businessAreaIds = helpers.getBusinessIdsFromBussiness(businessAreas);
              const companyTypeId = businessAreaIds[businessAreaIds.length - 1];

              this.store.dispatch(setOffice({
                ...office,
                businessAreas,
                businessAreaIds
              }));

              // Obtenemos los jobtypes traducidos para el cliente
              this.jobtypeService.index(companyTypeId, consultant.client.id).subscribe(
                jobtypes => {
                  jobtypes.map(jobtype => jobtype.name = this.translateService.instant('JOBTYPES.' + jobtype.randstadJobtype))
                  this.store.dispatch(setJobtypes({ jobtypes }))
                },
                error => {
                  // this.utilsService.toast('error', 'CannotGetJobtypes', true, this.utilsService.getNacsData({ endpoint: 'GET' + AppConfig.settings.API + ' /jobtypes', body: { companyTypeId: companyTypeId }, error: { errorType: error.errorType, errorCode: error.errorCode, message: error.message } }));
                  this.authenticationService.logOut('consultant');
                  return false;
                }
              );

              // Obtenemos los modelos de test de ct (internacional solo usa esos)
              this.testService.getModels('ct').subscribe(
                testModels => {
                  // Si el país es México se meten solo las de ADN
                  if (consultant.client.id == 3) { testModels = testModels.filter(testModel => [1, 2].includes(testModel.id)) }
                  this.store.dispatch(setTestModels({ testModels }))
                }, error => {
                  this.utilsService.toast('error', 'CannotGetTestModels', true, this.utilsService.getNacsData({ endpoint: 'GET' + AppConfig.settings.API + ' /tests/types', body: '', error: { errorType: error.errorType, errorCode: error.errorCode, message: error.message } }));
                  this.authenticationService.logOut('consultant');
                  return false;
                }
              );

              // Obtenemos los procesos de ese cliente
              this.processService.search({ name: '', clientId: consultant.client.id, officeId: office.id }, 0).pipe(take(1)).subscribe(
                processes => { this.store.dispatch(setProcesses(processes)); },
                error => {
                  this.utilsService.toast('error', 'CannotGetProcesses', true, this.utilsService.getNacsData({ endpoint: 'GET' + AppConfig.settings.API + ' /processes?origin=ct', body: { name: '', clientId: consultant.office.id, officeId: office.id }, error: { errorType: error.errorType, errorCode: error.errorCode, message: error.message } }))
                  this.authenticationService.logOut('consultant');
                  return false;
                }
              );
            });
          });
        }
      }
    });
  }
}
